import { Fragment } from "react";
import { Dialog, Transition } from "@headlessui/react";
import CloseModalButton from "../../../../components/Buttons/CloseModalButton";
import { DetailTicket } from "../../../../types/models/ticket.model.type";
import NextCollapseTicket from "../../../../components/next/NextCollapseTicket";
import { ActionType } from "../../../../types/states/ticket.state.type";
import FaIcon from "../../../../components/global/FaIcon";

declare type Props = {
  isOpen: boolean;
  onCloseModal: VoidFunction;
  tickets?: DetailTicket[] | undefined;
  action: ActionType | undefined;
  title: string;
};

const ModalTicketDetail = ({ isOpen, onCloseModal, tickets, action, title }: Props) => {
  return (
    <Transition appear show={isOpen} as={Fragment}>
      <Dialog as="div" className="relative z-10" onClose={() => {}}>
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-black bg-opacity-25" />
        </Transition.Child>
        <div className="fixed inset-0 bg-black/30" aria-hidden="true" />
        <div className="fixed inset-0 overflow-y-auto">
          <div
            className="flex min-h-full items-center justify-center p-4 text-center w-full"
            style={{ height: `calc(100vh - 12rem)` }}
          >
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 scale-95"
              enterTo="opacity-100 scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 scale-100"
              leaveTo="opacity-0 scale-95"
            >
              <Dialog.Panel className="w-full h-full transform overflow-hidden rounded-lg bg-white text-left align-middle shadow-xl transition-all">
                <Dialog.Title
                  as="h3"
                  className="text-lg font-medium leading-6 px-6 pt-4 pb-2 text-gray-900 flex items-center"
                >
                  <FaIcon icon="memo-pad" />
                  {title}
                  <CloseModalButton onClick={onCloseModal} />
                </Dialog.Title>
                {/*Scrollbar Start*/}
                <div style={{position: "relative", height: "100%", width: "100%", overflow: "hidden"}}>
                  <div style={{position: "absolute", inset: "0px", overflow: "auto"}}>
                    {tickets &&
                      tickets.map((ticket) => (
                        <NextCollapseTicket
                          ticket={ticket}
                          key={ticket.idTicket}
                          activePanel="collapse"
                          action={action}
                        />
                      ))}
                  </div>
                </div>
                {/*Scrollbar End*/}
                {/*<Scrollbars autoHide className="rounded-b-md next-scroll" height="100%">*/}
                {/*  {tickets &&*/}
                {/*    tickets.map((ticket) => (*/}
                {/*      <NextCollapseTicket*/}
                {/*        ticket={ticket}*/}
                {/*        key={ticket.idTicket}*/}
                {/*        activePanel="collapse"*/}
                {/*        action={action}*/}
                {/*      />*/}
                {/*    ))}*/}
                {/*</Scrollbars>*/}
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition>
  );
};

export default ModalTicketDetail;
